import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Products = () => {
  const navigate = useNavigate();
  // 👇 1. Estado para controlar la ventana emergente de "Próximamente"
  const [isComingSoonOpen, setIsComingSoonOpen] = useState(false);

  // 👇 2. Bloqueamos el scroll del fondo cuando el modal está abierto
  useEffect(() => {
    if (isComingSoonOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isComingSoonOpen]);

  return (
    <>
      <section 
        id="products" 
        className="relative scroll-mt-[80px] pt-[60px] pb-24 md:pt-[88px] md:pb-40 bg-white dark:bg-[#121212] overflow-x-hidden transition-colors duration-300"
      >
        {/* Textura de panal de fondo */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-5 dark:opacity-[0.02] pointer-events-none"
          style={{ backgroundImage: "url('/images/textura-panal.png')" }}
        ></div>

        {/* Contenedor principal */}
        <div className="max-w-full mx-auto relative z-10 flex flex-col gap-12 md:gap-20 overflow-visible px-4">

          {/* --- SECCIÓN 1: Derivados de las abejas --- */}
          <div className="relative w-full flex justify-start">
            <div className="bg-yellow-500 dark:bg-[#1a1a1a] rounded-3xl md:rounded-l-none md:rounded-r-full py-12 px-6 md:pl-6 md:pr-12 shadow-xl dark:shadow-none border border-transparent dark:border-yellow-900/20 relative w-full md:w-[70%] h-auto md:h-[450px] flex flex-col md:flex-row items-center z-10 transition-colors duration-300">
              <div className="md:hidden w-full h-48 flex justify-center mb-6">
                <img src="/images/products/miel_1.webp" alt="Miel" className="h-full object-contain drop-shadow-2xl" />
              </div>
              <div className="w-full md:ml-16 flex items-center justify-between">
                <div className="flex-1 text-center md:text-left">
                  <h2 className="text-3xl md:text-5xl font-bold text-yellow-950 dark:text-yellow-500 mb-4">Derivados de las abejas</h2>
                  <p className="text-base md:text-xl text-yellow-900 dark:text-yellow-100/80 mb-6 max-w-xl mx-auto md:mx-0 font-medium">
                    Aprovechamos la Miel, la Jalea Real, el Polen, el Própoleo, la Cera y la Apitoxina.
                  </p>
                  <button onClick={() => navigate('/catalog')} className="bg-yellow-950 dark:bg-yellow-600 text-white py-3 px-8 rounded-full font-bold transform hover:scale-105 transition">
                    Ver Productos
                  </button>
                </div>
                <div className="hidden md:block w-[40%]"></div>
              </div>
              <img src="/images/products/miel_1.webp" alt="Miel" className="hidden md:block absolute top-1/2 -translate-y-1/2 right-0 transform translate-x-[50%] h-[100%] object-contain drop-shadow-2xl z-20" />
            </div>
          </div>

          {/* --- SECCIÓN 2: Material Apícola --- */}
          <div className="relative w-full flex justify-end">
            <div className="bg-yellow-500 dark:bg-[#1a1a1a] rounded-3xl md:rounded-r-none md:rounded-l-full py-12 px-6 md:pr-6 md:pl-12 shadow-xl dark:shadow-none border border-transparent dark:border-yellow-900/20 relative w-full md:w-[70%] h-auto md:h-[450px] flex flex-col md:flex-row-reverse items-center z-10 transition-colors duration-300">
              <div className="md:hidden w-full h-48 flex justify-center mb-6">
                <img src="/images/colmena.webp" alt="Material" className="h-full object-contain drop-shadow-2xl" />
              </div>
              <div className="w-full md:mr-16 flex items-center justify-between">
                <div className="hidden md:block w-[40%]"></div>
                <div className="flex-1 text-center md:text-right">
                  <h2 className="text-3xl md:text-5xl font-bold text-yellow-950 dark:text-yellow-500 mb-4">Material Apícola</h2>
                  <p className="text-base md:text-xl text-yellow-900 dark:text-yellow-100/80 mb-6 max-w-xl mx-auto md:ml-auto md:mr-0 font-medium">
                    Creamos el mejor material para que las abejas tengan un excelente hogar.
                  </p>
                  {/* 👇 3. Cambiamos el onClick para abrir nuestra ventana llamativa */}
                  <button onClick={() => setIsComingSoonOpen(true)} className="bg-yellow-950 dark:bg-yellow-600 text-white py-3 px-8 rounded-full font-bold transform hover:scale-105 transition">
                    Ver Material
                  </button>
                </div>
              </div>
              <img src="/images/colmena.webp" alt="Material" className="hidden md:block absolute top-1/2 -translate-y-1/2 left-0 transform -translate-x-[50%] h-[100%] object-contain drop-shadow-2xl z-20" />
            </div>
          </div>

          {/* --- SECCIÓN DE PREVIEW DEL TRÍPTICO --- */}
          <div className="w-full max-w-6xl mx-auto flex flex-col items-center">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-black text-yellow-950 dark:text-white mb-2">
                Nuestro Tríptico
              </h2>
              <div className="w-16 h-1 bg-orange-500 mx-auto rounded-full"></div>
            </div>

            <div className="flex flex-col gap-8 w-full px-4 mb-12">
              <div className="overflow-hidden rounded-2xl shadow-xl border border-gray-100 dark:border-white/5">
                <img src="/images/triptico_1.webp" alt="Tríptico Cara 1" className="w-full h-auto object-cover" />
              </div>
              <div className="overflow-hidden rounded-2xl shadow-xl border border-gray-100 dark:border-white/5">
                <img src="/images/triptico_2.webp" alt="Tríptico Cara 2" className="w-full h-auto object-cover" />
              </div>
            </div>

            <div className="flex justify-center">
              <a 
                href="/docs/triptico_paa.pdf" 
                download="Triptico_PAA_Oficio.pdf"
                className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-orange-500/40 transform hover:scale-105 uppercase tracking-wider text-sm"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Descargar PDF
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 👇 4. VENTANA EMERGENTE (MODAL) LLAMATIVA 👇 */}
      {isComingSoonOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
          {/* Fondo desenfocado */}
          <div 
            className="absolute inset-0 bg-black/60 backdrop-blur-md animate-fade-in" 
            onClick={() => setIsComingSoonOpen(false)}
          ></div>
          
          {/* Contenido del Modal */}
          <div className="relative bg-[#FFFBF0] dark:bg-[#1C1B17] w-full max-w-md rounded-[2.5rem] p-8 md:p-12 text-center shadow-[0_20px_50px_rgba(0,0,0,0.3)] border-b-8 border-yellow-500 animate-fade-up">
            
            {/* Botón de cierre */}
            <button 
              onClick={() => setIsComingSoonOpen(false)}
              className="absolute top-4 right-4 text-yellow-900 dark:text-yellow-500 hover:rotate-90 transition-transform duration-300 text-3xl font-bold"
            >
              &times;
            </button>

            {/* Icono de Hexágono Animado */}
            <div className="flex justify-center mb-6">
              <div 
                className="w-20 h-20 bg-yellow-500 dark:bg-[#FFD54F] flex items-center justify-center shadow-lg animate-bounce"
                style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
              >
                <span className="text-3xl">🛠️</span>
              </div>
            </div>

            <h3 className="text-3xl font-black text-yellow-950 dark:text-yellow-500 mb-4 uppercase tracking-tighter">
              ¡Próximamente!
            </h3>
            
            <p className="text-lg text-yellow-900 dark:text-yellow-100/80 mb-8 font-medium leading-relaxed">
              Estamos trabajando para ofrecerte la mejor selección de <strong>equipo apícola, colmenas y herramientas</strong> de alta durabilidad.
            </p>

            <div className="bg-yellow-100 dark:bg-[#2A2821] py-3 px-6 rounded-2xl mb-8">
              <p className="text-sm font-bold text-yellow-800 dark:text-[#FFD54F] uppercase tracking-widest">
                Disponible muy pronto
              </p>
            </div>

            <button 
              onClick={() => setIsComingSoonOpen(false)}
              className="w-full bg-yellow-950 dark:bg-yellow-600 text-white font-black py-4 rounded-2xl shadow-lg hover:shadow-yellow-500/30 transform hover:scale-[1.02] transition-all uppercase tracking-widest"
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Products;